import $ from 'jquery';
import fetch from 'dva/fetch';
// import Lang from '../../nls/Sales/sales_Lang';
import { Dialog } from '@alife/next';
// import { message } from 'antd';

function parseJSON(response) {
  let json = response.json();
  return json;
}

function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  const error = new Error(response.statusText);
  error.response = response;

  // message.error(Lang.page_common_000038);
  Dialog.error({
    // content: Lang.page_common_000038,
    language: window.language == 'en_US' ?'en-us' : 'zh-cn'
  });
  throw error;
}

function checkResponse(resp) {
  if (resp.code && resp.code != 200) {
    // message.error(`${Lang.page_common_000039}: ${Lang[resp.msgCode]}`, 2);
    // const arr = ['sales-sop-1009'];
    // const msgCode = resp.code;
    // const message = resp.message.split('#');
    // let cidName = '';
    // arr.forEach((o) => {
    //   cidName = msgCode == o ? message[0] : '';
    // });
    Dialog.error({
      content: resp.message,
      // content: `${Lang.page_common_000039}:${cidName}${Lang[msgCode]}`,
      language: window.language == 'en_US' ?'en-us' : 'zh-cn'
    });
  }
  return resp;
}

/**
 * Requests a URL, returning a promise.
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 * @return {object}           An object containing either "data" or "err"
 * @param  {object} [checkResCode] 非200状态码自定义处理方式
 */
export function request(url, options, checkResCode) {
  let new_options = {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-XSRF-TOKEN': window.GLOBAL_CONFIG.csrf_val
    },
    ...options
  };
  // checkResCode = checkResCode ? checkResCode : checkResponse;
  return fetch(url, new_options)
    .then(checkStatus)
    .then(parseJSON)
    .then(checkResCode)
    .then(resp => (resp))
    .catch(err => {
      console.log(err);
    });
}

export function requestWithoutCredentials(url, options) {
  return fetch(url, options)
    .then(checkStatus)
    .then(parseJSON)
    .then(checkResponse)
    .then(resp => (resp))
    .catch(err => ( err ));
}

export function Ajax(url, { method, body }) {
  const opts = {
    method: method || 'GET',
    data: body || {}
  };
  if (method && method.toUpperCase() === 'POST') {
    opts.contentType = 'application/json';
    opts.processData = false;
    opts.data = JSON.stringify(body || {});
  }
  opts.headers = {
    'X-CSRF-TOKEN': window.GLOBAL_CONFIG.csrf_val
  };
  return $.ajax(url, opts)
    .done((d) => {
      return Promise.resolve(d);
    })
    .fail(() => {
      return Promise.reject({});
    });
}


// WEBPACK FOOTER //
// ./src/scripts/utils/request.js